export default __webpack_public_path__ + "static/media/assessmentIcon.92f6eb1a.svg";